import styled from "styled-components";
import media from "styled-media-query";
import breakpoints from "../../framework/helpers/BreakpointHelper";
import { FlexContainer } from "../../BaseComponents/Flex/FlexContainer";

export const BreadcrumbsWrapper = styled(FlexContainer).attrs(({ smallpadding }) => ({
	smallpadding: smallpadding ? smallpadding : "",
}))`
	background-color: ${({ bgColor }) => (bgColor ? bgColor : "")};

	max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : "")};
	width: ${({ width }) => (width ? width : "")};
	align-items: center;
	width: unset;
	transition: 0.2s ease;
	flex-direction: row;
	display: flex ${media.lessThan(breakpoints.ipad)`
	padding: ${({ mediumpadding }) => (mediumpadding ? mediumpadding : "")}
       
    `} ${media.lessThan(breakpoints.mobile)`
	padding: ${({ mobilepadding }) => (mobilepadding ? mobilepadding : "")}
       
    `} ${media.greaterThan(breakpoints.ipad)`
	margin: 0 auto;

       
    `};
`;
